import { render, staticRenderFns } from "./DepartmentTreeRadios.vue?vue&type=template&id=09d52116&"
import script from "./DepartmentTreeRadios.vue?vue&type=script&lang=js&"
export * from "./DepartmentTreeRadios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports